module.exports = global.config = {
    serverUrl: "https://api.thatsmypet.org",
    // serverUrl: "http://localhost:8080",
    unitPrice: 20.0,
};
